import React from "react";
import Form from "antd/lib/form";
import Input from "antd/lib/input";
import message from "antd/lib/message";
import Radio from "antd/lib/radio";
import { Link } from "react-router-dom";
import gspAuth from "../../services/GSPService";
import { compose } from "redux";
import { connect } from "react-redux";

import { Button, ContentWrapper as Content } from "../../shared/styles";
import { ROUTES, i18n } from "../../shared/constants";
// import { ROUTES, } from "../../shared/constants";
import { FormItem } from "../../shared/utils";
import { actions } from "../../redux";
import Col from 'antd/lib/col'
import Select from 'antd/lib/select'
import moment from 'moment';

import { DatePicker, Space, Dropdown, Card } from 'antd';
// import dayjs from "dayjs"



// import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { props } from "lodash/fp";
import get from 'lodash/get'
// const { RangePicker } = DatePicker;

const add_button = {
  outline: "0",
  display: "inline-block",
  marginBottom: "0",
  fontWeight: "500",
  textAlign: "center",
  touchAction: "manipulation",
  cursor: "pointer",
  backgroundImage: "none",
  border: "1px solid transparent",
  whiteSpace: "nowrap",
  lineHeight: "1.45",
  padding: "0 15px",
  fontSize: "14px",
  borderRadius: "4px",
  height: "35px",
  mozUserSelect: "none",
  position: "relative",
  backgroundColor: "#D7D8D9",
  borderColor: "#d9d9d9",
  paddingTop: "6px",
  width: '146px',
  color: "black"

};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 14,
      offset: 6,
    },
  },
};

const handleKeyDown = e => {
  if (e.key === " ") {
    e.preventDefault();
  }
};
const handleChange = e => {
  if (e.currentTarget.value.includes(" ")) {
    e.currentTarget.value = e.currentTarget.value.replace(/\s/g, "");
  }
};
const PaymentAdd = (props) => (


  <Content>
    <Card>
{console.log(".....company____paymentADD___",props.company)}
      <Form.Item style={{ textAlign: "center", fontSize: '20px', padding: '25px', fontWeight: 'bold' }}>
        <label type="primary" >
          {props.isEdit ? "Edit" : "Add"} Paid Client Details
        </label>
      </Form.Item>
      <Form onSubmit={props.saveClient}>
        <FormItem label="GSTIN">
          {props.getFieldDecorator("gstin", {
            //rules: [{ required: true, message: 'Please input GSTIN!' }],
            initialValue: props.company ? props.company[0].gstin : "",
          })(
            <Input
              id="gstId"
              onBlur={props.getCompanyName}
              placeholder="GSTIN"
              // disabled={props.isEdit}
              type="text"
              maxLength="15"
              required
              style={{ width: "74%" }}
            />

          )}
         
        </FormItem>
        <FormItem label="Company Name">
          {props.getFieldDecorator("name", {
            //rules: [{ required: true, message: 'Please input Company Name!' }],
            initialValue: props.company ? props.company[0].name : "",
          })(
            <Input
              disabled="true"
              placeholder="Company Name"
              maxLength="70"
              required
              style={{ width: "74%" }}
            />
          )}

          
        </FormItem>
        {/* <FormItem label="GSTN UserName">
          {props.getFieldDecorator("gstnUserName", {
            //rules: [{ required: true, message: 'Please input GSTN UserName!' }],
            initialValue: props.company ? props.company.gstnUserName : "",
          })(
            <Input
              id="gstnUserName"
              placeholder="GSTN UserName"
              type="text"
              maxLength="15"
              required
              style={{ width: "74%" }}
            />
          )}
        </FormItem> */}

        <FormItem label="Email ID">
          {props.getFieldDecorator("email", {
            initialValue: props.company ? props.company[0].email : "",
            rules: [
              { required: true, message: i18n.en.login.email_required_message, },
              { pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: i18n.en.login.email_validation_required_message },


            ]

          })(
            <Input
              id="emaiid"
              onKeyDown={handleKeyDown}
              onChange={handleChange}
              placeholder={i18n.en.login.email_placeholder_message}
              type="email"
              required
              style={{ width: "74%" }}
            />
          )}
        </FormItem>
        <FormItem label="Phone number">
          {props.getFieldDecorator("phone_number", {
            initialValue: props.company ? props.company[0].phone_number : "",
            // rules: [{ required: true, message: 'Please input Phone number!' }],

          })(
            <Input
              id="Phone_Number"
              placeholder="Phone Number"
              type="number"
              required
              style={{ width: "74%" }}
            />
          )}
        </FormItem>


        <FormItem label="Payment Date">
          {props.getFieldDecorator("payment_date", {
            initialValue: props.company ? moment(Number( props.company[0].payment_date)) : "",
          })(
            <DatePicker
            format="DD-MM-YYYY"
              placeholder="Start"
            />

          )}
        </FormItem>


        <FormItem label="Exprie Date">
          {props.getFieldDecorator("expire_date", {
            initialValue: props.company ? moment(Number( props.company[0].expire_date)) : "",
            
            rules: [{ required: true, message: 'Please input Exprie Date!' }],

          })(
            <DatePicker

            format="DD-MM-YYYY"
            placeholder="End"

            />
          )}
        </FormItem>
        <FormItem label="Status">
          {props.getFieldDecorator("status", {
            initialValue: props.company ? props.company[0].status : "",
            // rules: [{ required: true, message: 'Please input Phone number!' }],

          })(
            
              <Select id="status" name="status" style={{ width: '120px', marginLeft: "10px", backgroundColor: "white" }} disabled={false}>
                <Select.Option value="Pending">Pending</Select.Option>
                <Select.Option value="verify">verify</Select.Option>
                <Select.Option value="paid">paid</Select.Option>

              </Select>
            
          )}
        </FormItem>


        <Form.Item style={{ display: "flex", justifyContent: "center", textAlign: "center", height: '10px', padding: "0px 0px 36px 0px" }} >
          <a style={add_button} id="back">
            <Link to={ROUTES.PAYMENT}>Back</Link>
          </a>
          <Button style={{ color: "white", backgroundColor: "#09537C", width: '146px', height: '35px', marginLeft: "10px" }} htmlType="submit">
            {props.isEdit ? "Update" : "Submit"}  
          </Button>

        </Form.Item>
      </Form>
    </Card>
  </Content>
);

function validateGSTN(gstn) {
  // var rx = /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[0-9a-zA-Z]{3})+$/;
  // if (rx.test(gstn) === false) {
  //   if (gstn.substr(0, 2) !== "97") {
  //     return false;
  //   }
  // }
  // if (gstn.substr(0, 2) === "28") {
  //   return false;
  // }
  // return true;

  // New Validation for GSTIN
  const rx1 = /[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Zz1-9A-Ja-j]{1}[0-9a-zA-Z]{1}/;
  const rx2 = /[0-9]{4}[A-Z]{3}[0-9]{5}[UO]{1}[N][A-Z0-9]{1}/;
  const rx3 = /[0-9]{2}[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}[0-9]{1}[Z]{1}[0-9]{1}/;
  const rx4 = /[0-9]{4}[a-zA-Z]{3}[0-9]{5}[N][R][0-9a-zA-Z]{1}/;
  const rx5 = /[0-9]{2}[a-zA-Z]{4}[a-zA-Z0-9]{1}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[D]{1}[0-9a-zA-Z]{1}/;
  const rx6 = /[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[C]{1}[0-9a-zA-Z]{1}/;
  const rx7 = /[9][9][0-9]{2}[a-zA-Z]{3}[0-9]{5}[O][S][0-9a-zA-Z]{1}/;
  return (rx1.test(gstn) || rx2.test(gstn) || rx3.test(gstn) || rx4.test(gstn) || rx5.test(gstn) || rx6.test(gstn) || rx7.test(gstn))
}

class PaymentAddContainer extends React.Component {




  saveClient = async (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (err) return;
      values.gstin = values.gstin.toUpperCase();
      var gstn = values.gstin;
      var turnover_2016 = values.turnover_2016;
      var turnover_2017 = values.turnover_2017;
      var pincode = values.pincode;
      var len = gstn.length;

      var turnpatt = new RegExp("^[0-9][0-9]*.[0-9]{2}$");
      var pattern = new RegExp("^[0-9][0-9]*$");
      var pinpatt = new RegExp("^[0-9]{6}");

      var res2016 = pattern.test(turnover_2016);
      var res2017 = pattern.test(turnover_2017);
      var resPin = pinpatt.test(pincode);
      if (res2016) {
        turnover_2016 = turnover_2016 + ".00";
      }
      if (res2017) {
        turnover_2017 = turnover_2017 + ".00";
      }

      var val2016 = parseFloat(turnover_2016);
      var val2017 = parseFloat(turnover_2017);

      var turnres2016 = turnpatt.test(turnover_2016);
      var turnres2017 = turnpatt.test(turnover_2017);
      if (pincode !== "" && pincode !== null && pincode !== undefined) {
        if (pincode.length !== 6) {
          message.error("Enter Valid Pincode");
          return;
        } else if (!resPin) {
          message.error("Enter Valid Pincode");
          return;
        }
      }
      if (len !== 15) {
        message.error("Entered GSTIN should contain 15 characters.");
        return;
      } else if (validateGSTN(gstn) === false) {
        message.error("GSTIN entered is Invalid");
        return;
      } else {
        try {
          await this.props.mutate(values);
          // Reset fields only when adding new company
          !this.props.isEdit && this.props.form.resetFields();
          message.success("Company saved successfully!");
          window.history.back();
        } catch (e) {
          message.error(e.graphQLErrors[0].message);
        }
      }
    });
  };
  getCompanyName = async (e) => {
    // console.log(e.target.value);
    const gstin = e.target.value.toUpperCase();
    e.preventDefault();
    if (gstin.length === 15) {
      const resp = await gspAuth.getCompanyName(gstin);
      if (!resp || resp.data.success === false) {
        return false;
      }
      this.props.form.setFieldsValue({
        name: resp.data.resp,
        gstin: gstin
      });
    }
  };
  render() {
    console.log("------Payment Form-----");
    console.log("......check____this____data",this.props);
    if (this.props.company) {
      {
        // this.props.changeCompany(this.props.company.sub_type);
        this.props.changeCompany(this.props.company.email);
        this.props.changeCompany(this.props.company.phone_numer);
        //this.props.changeCompany(this.props.comapny.payment_date);
        this.props.changeCompany(this.props.company.expire_date);
        this.props.changeCompany(this.props.company.status);
      }
    }

    return (
      <PaymentAdd
        handleChange={this.handleChange}
        saveClient={this.saveClient}
        getFieldDecorator={this.props.form.getFieldDecorator}
        company={this.props.company}
        getCompanyName={this.getCompanyName}
        isEdit={this.props.isEdit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // selectedCompany: state.local.selectedCompany,
    finMonth: state.local.finMonth,
    finYear: state.local.finYear,
    // sub_type: state.local.sub_type,
  };
};

export default compose(
  Form.create(),
  connect(mapStateToProps, {
    changeSelectedCompany: actions.changeSelectedCompany,
    changeCompany: actions.changeCompany,
  })
)(PaymentAddContainer);
